import {css, type Theme} from '@emotion/react';
import {configureFonts, getFontThemeList} from '@nfq/next-fonts';
import {createConfig} from '@nfq/react-grid';

import {globalCss, shadows, themeColors} from 'UI/utils/theme';

export const fontDefinitions = configureFonts({
    Geist: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '400 500',
            preload: true,
            src: '/fonts/geistmono-variablefont_wght.woff2'
        }
    ],
    Poppins: [
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '400',
            preload: true,
            src: '/fonts/poppins-regular.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '500',
            preload: true,
            src: '/fonts/poppins-medium.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'normal',
            fontWeight: '700',
            preload: true,
            src: '/fonts/poppins-bold.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'italic',
            fontWeight: '400',
            preload: true,
            src: '/fonts/poppins-italic.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'italic',
            fontWeight: '500',
            preload: true,
            src: '/fonts/poppins-mediumitalic.woff2'
        },
        {
            fontDisplay: 'swap',
            fontStyle: 'italic',
            fontWeight: '700',
            preload: true,
            src: '/fonts/poppins-bolditalic.woff2'
        }
    ]
});

export const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export const {configType, globalCss: globalGridCss} = createConfig(breakpoints, {
    baseSpacing: 0.4,
    columnGap: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 24,
        xxl: 24
    },
    container: {
        xs: 'fluid',
        sm: 'fluid',
        md: 'fluid',
        lg: 'fluid',
        xl: 1440,
        xxl: 1440
    },
    containerPadding: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 24,
        xxl: 24
    }
});

export const theme: Theme = {
    boxShadows: shadows,
    colors: themeColors,
    fonts: getFontThemeList(fontDefinitions)
};

export const globals = css`
    ${globalCss}

    ${globalGridCss}

    *,
    &::before,
    &::after {
        box-sizing: border-box;
    }

    * {
        -webkit-tap-highlight-color: transparent;
    }

    html {
        display: flex;
        flex-direction: column;
        font-size: 10px;
        min-height: 100%;
    }

    html, body {
        margin: 0;
        min-height: 100%;
        position: relative;
        scroll-behavior: smooth;
        scroll-padding-top: 100px;
    }

    body {
        background-color: ${themeColors.neutral0};
        color: ${themeColors.textPrimary};
        display: flex;
        flex: 1 2 auto;
        flex-direction: column;
        padding: 0;
    }

    #__next {
        display: flex;
        flex: 1 2 auto;
        flex-direction: column;
        min-height: 100%;
    }
`;